

























import Vue from "vue";

interface Props {
  error?: string;
  value: string;
}

/**
 * @emits input standard v-model
 * @emits input-backward-compatible send the whole event for existing code
 */
export default Vue.extend<{}, {}, {}, Props>({
  name: "JzInput",
  props: {
    error: { type: String, default: undefined },
    value: { type: String, required: true }
  },
  computed: {
    // this is necessary so that we don't pass down multiple "input" listeners but can still pass any other listeners
    // we may need
    computedListeners() {
      const newListeners = Object.entries(this.$listeners).filter(([name]) => {
        return !name.includes("input");
      });

      return [...newListeners].reduce((obj: any, [key, val]) => {
        obj[key] = val;
        return obj;
      }, {});
    }
  }
});
